import * as React from 'react';
import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogHeader,
	DialogTitle,
} from '@/components/ui/dialog';

interface ProgressDialogProps {
	isOpen: boolean;
	title: string;
	description: string;
	current: number;
	total: number;
}

export function ProgressDialog({
	isOpen,
	title,
	description,
	current,
	total,
}: ProgressDialogProps) {
	return (
		<Dialog open={isOpen}>
			<DialogContent className='max-w-md !p-8 [&>button]:hidden'>
				<DialogHeader className='mb-6'>
					<DialogTitle className='text-xl'>{title}</DialogTitle>
					<DialogDescription className='text-base mt-2'>
						{description}
					</DialogDescription>
				</DialogHeader>
				<div className='w-full mt-2 p-4'>
					<div className='w-full h-4 bg-purple-100 rounded-full overflow-hidden'>
						<div
							className='h-full bg-purple-600 transition-all duration-300 ease-in-out'
							style={{ width: `${(current / total) * 100}%` }}
						/>
					</div>
					<p className='text-center mt-4 text-sm text-orange-500 font-medium'>
						{current} of {total} profiles processed. 🔥🔥🔥
					</p>
				</div>
			</DialogContent>
		</Dialog>
	);
}
